import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function (theme, _ref) {
  var inline = _ref.inline;
  return {
    root: {
      display: inline ? "inline-flex" : "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  };
});
export default useStyles;